import { DateTime } from 'luxon';

const getEventStartAtFromMinutes = ({
    minute,
    selectedDate = Date.now(),
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: {
    minute: number,
    selectedDate?: Date | number,
    timeZone?: string;
}) => {
    const quarterMin = Math.floor(minute / 15) * 15;
    const hours = Math.floor(quarterMin / 60);
    const minutes = quarterMin - hours * 60;
    return DateTime.fromJSDate(new Date(selectedDate))
        .setZone(timeZone)
        .startOf('day')
        .set({
            hour: hours,
            minute: minutes,
            second: 0,
            millisecond: 0,
        })
        .toJSDate();
};

export default getEventStartAtFromMinutes;
